import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Sheet, SheetContent, SheetHeader, SheetTitle } from '@mono/ui-components';
import { GitMerge } from 'lucide-react';
import { memo, useState } from 'react';
import { useProjectFiles } from '../../hooks/useProjectFiles';
import { ProjectFilesSection } from '../ProjectDashboard/ProjectFilesSection';
import { DocumentRelationshipGraph } from './DocumentRelationshipGraph';
export const FilesTab = /*#__PURE__*/ memo(function FilesTab({ projectId, userRole, isArchived }) {
    const canEdit = userRole === 'owner' || userRole === 'member';
    const [graphOpen, setGraphOpen] = useState(false);
    const { data } = useProjectFiles(projectId);
    const hasClassifications = data?.files?.some((f)=>f.classification?.documentType);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "space-y-0",
                children: [
                    hasClassifications && /*#__PURE__*/ _jsx("div", {
                        className: "px-6 pt-4 flex justify-end",
                        children: /*#__PURE__*/ _jsxs(Button, {
                            variant: "outline",
                            size: "sm",
                            onClick: ()=>setGraphOpen(true),
                            className: "text-xs gap-1.5",
                            children: [
                                /*#__PURE__*/ _jsx(GitMerge, {
                                    className: "h-3.5 w-3.5"
                                }),
                                "Document Graph"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ProjectFilesSection, {
                        projectId: projectId,
                        canEdit: canEdit,
                        isArchived: isArchived
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Sheet, {
                open: graphOpen,
                onOpenChange: setGraphOpen,
                children: /*#__PURE__*/ _jsxs(SheetContent, {
                    side: "right",
                    className: "w-[520px] sm:w-[580px] overflow-y-auto p-0",
                    children: [
                        /*#__PURE__*/ _jsxs(SheetHeader, {
                            className: "px-6 pt-6 pb-4 border-b border-gray-100 sticky top-0 bg-white z-10",
                            children: [
                                /*#__PURE__*/ _jsxs(SheetTitle, {
                                    className: "flex items-center gap-2 text-base",
                                    children: [
                                        /*#__PURE__*/ _jsx(GitMerge, {
                                            className: "h-4 w-4 text-blue-600"
                                        }),
                                        "Document Relationship Graph"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-xs text-gray-500 mt-1",
                                    children: "Solicitation package structure and amendment history"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "p-4",
                            children: data?.files && /*#__PURE__*/ _jsx(DocumentRelationshipGraph, {
                                files: data.files
                            })
                        })
                    ]
                })
            })
        ]
    });
});
